import {STATO_COMPLETO} from "../../../utility/common";
import React, {Fragment} from "react";
import {Link} from "react-router-dom";
import Translate from "../../../components/Translate";

export default function MenuCertificati({
                                            user,
                                            isRuoloSocio,
                                            isRuoloAdmin,
                                            isRuoloSegreteria,
                                            showMessage,
                                        }) {

    return <Fragment>
        {
            (isRuoloAdmin() || isRuoloSegreteria()) &&
            <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="utenti-menu"
                   role="button"
                   data-bs-toggle="dropdown" aria-expanded="false">
                    <i className="fas fa-file-signature"/> Certificati
                </a>
                <ul className="dropdown-menu" aria-labelledby="utenti-menu">
                    <li>
                        <Link to="/list-certificati" className="dropdown-item">
                            <div data-bs-toggle="collapse"
                                 data-bs-target=".navbar-collapse.show">
                                <i className="fas fa-file-signature"/>
                                <Translate>Lista certificati</Translate>
                            </div>
                        </Link>
                    </li>
                    <li>
                        <Link to="/list-documenti-firmati" className="dropdown-item">
                            <div data-bs-toggle="collapse"
                                 data-bs-target=".navbar-collapse.show">
                                <i className="fas fa-signature"/>
                                <Translate>Archivio documenti firmati</Translate>
                            </div>
                        </Link>
                    </li>
                </ul>
            </li>
        }
        {
            !isRuoloSocio() && !isRuoloAdmin() && !isRuoloSegreteria() &&
            <li className="nav-item">
                <Link className="nav-link" aria-current="page"
                      to="/list-certificati">
                    <div data-bs-toggle="collapse"
                         data-bs-target=".navbar-collapse.show">
                        <i className="fas fa-file-signature"/> Certificati
                    </div>
                </Link>
            </li>
        }
        {
            isRuoloSocio() && (user && user.stato == STATO_COMPLETO) &&
            <li className="nav-item">
                <Link className="nav-link" aria-current="page"
                      to="/list-certificati">
                    <div data-bs-toggle="collapse"
                         data-bs-target=".navbar-collapse.show">
                        <i className="fas fa-file-signature"/> Certificati
                    </div>
                </Link>
            </li>
        }
        {
            isRuoloSocio() && user && user.stato != STATO_COMPLETO &&
            <li className="nav-item">
                <button type={"button"} className="nav-link nav-link-btn"
                        aria-current="page"
                        onClick={() => {
                            showMessage("Certificati", "In questa pagina potrai richiedere e visualizzare i tuoi certificati, non appena la tua richiesta di adesione verrà approvata.");
                        }}>
                    <div data-bs-toggle="collapse"
                         data-bs-target=".navbar-collapse.show">
                        <i className="fas fa-file-signature"/> Certificati
                    </div>
                </button>
            </li>
        }
    </Fragment>
}